import './login.css';
import { useState } from 'react';
import { useAuth, User } from '../context/context';
import { useNavigate } from 'react-router-dom';
import { post } from './utils/utils';

export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  function onLogin(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();

    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    post({
      url: 'login.php',
      data: formData,
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status === 'ok') {
          const userData: User = {
            id: data.userId,
            token: data.token
          };
          login(userData);
          localStorage.setItem('user', JSON.stringify(userData));
          navigate('/hoy');
        }
      })
      .catch((error) => {
        console.log(error.response)
        setErrorMessage(error.response.data.message);
      });
  }

  return (
    <div className="options-container">
        <form onSubmit={onLogin} className='options-new-item'>
          <p style={{textAlign: 'center', color: 'red'}}>{errorMessage}</p>
          <strong>Iniciar sesión</strong>
          <div className="options-new-item-input">
            <label htmlFor="username">Usuario: </label>
            <input
              type="text"
              required
              id="username"
              className="agenda-input"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </div>
          <div className="options-new-item-input">
            <label htmlFor="password">Contraseña: </label>
            <input
              type="password"
              required
              id="password"
              className="agenda-input"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <div className='submit-btn'>
            <button type='submit' className='btn'>
                Ingresar
            </button>
          </div>
        </form>

    </div>
  );
}
